export default __webpack_public_path__ + "images/bb9f1f8d917fff10d0587496ee1e8cfd.svg";